"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotifications = exports.setNotificationsComplete = exports.getNotificationCount = exports.setNotificationCount = exports.fetchDeviceConstants = exports.fetchUiCommonConstants = exports.fetchUiCommonConfig = exports.setUiCommonConstants = exports.setUiCommonConfig = exports.fetchdeviceinfo = exports.fetchActionItems = exports.searchActionItemError = exports.fetchCurrentLocation = exports.addBreadCrumbs = exports.fetchLocalizationLabel = exports.toggleSnackbarAndSetText = exports.setBottomNavigationIndex = exports.setPreviousRoute = exports.setRoute = exports.updateActiveRoute = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _api = require("egov-ui-kit/utils/api");

var _commons = require("egov-ui-kit/utils/commons");

var _common = require("config/common");

var _common2 = _interopRequireDefault(_common);

var _util = require("util");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _localStorageUtils2 = require("../../utils/localStorageUtils");

var _actions = require("../auth/actions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateActiveRoute = exports.updateActiveRoute = function updateActiveRoute(routePath, menuName) {
  (0, _localStorageUtils.localStorageSet)("menuPath", routePath);
  (0, _localStorageUtils.localStorageSet)("menuName", menuName);
  return { type: actionTypes.UPDATE_ACTIVE_ROUTE_PATH, routePath: routePath };
};

var setRoute = exports.setRoute = function setRoute(route) {
  return { type: actionTypes.SET_ROUTE, route: route };
};

var setPreviousRoute = exports.setPreviousRoute = function setPreviousRoute(route) {
  return { type: actionTypes.SET_PREVIOUS_ROUTE, route: route };
};

var setBottomNavigationIndex = exports.setBottomNavigationIndex = function setBottomNavigationIndex(bottomNavigationIndex) {
  return { type: actionTypes.CHANGE_BOTTOM_NAVIGATION_INDEX, bottomNavigationIndex: bottomNavigationIndex };
};

var setLocalizationLabels = function setLocalizationLabels(locale, localizationLabels) {
  window.localStorage.removeItem("localization_" + locale);
  window.localStorage.setItem("localization_" + locale, JSON.stringify(localizationLabels));
  (0, _localStorageUtils.setLocale)(locale);
  return { type: actionTypes.ADD_LOCALIZATION, locale: locale, localizationLabels: localizationLabels };
};

var toggleSnackbarAndSetText = exports.toggleSnackbarAndSetText = function toggleSnackbarAndSetText(open) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var variant = arguments[2];

  return {
    type: actionTypes.SHOW_TOAST,
    open: open,
    message: message,
    variant: variant
  };
};

var fetchLocalizationLabel = exports.fetchLocalizationLabel = function fetchLocalizationLabel(locale, module, tenantId) {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var moduleNamecmn, moduleName, localeModule, payload1, payload2, resultArray;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // const commonModules =
              // "rainmaker-pgr,rainmaker-pt,rainmaker-tl,finance-erp,rainmaker-common,rainmaker-hr,rainmaker-uc,rainmaker-noc,rainmaker-abg,rainmaker-bpareg,rainmaker-ws,rainmaker-dss,rainmaker-bpa,rainmaker-pm,rainmaker-pension,rainmaker-pr,rainmaker-hc,rainmaker-ec,rainmaker-store-asset,rainmaker-nulm";

              moduleNamecmn = 'rainmaker-common';
              moduleName = (0, _localStorageUtils2.getModule)();

              if (moduleName === 'rainmaker-pt') moduleNamecmn = 'rainmaker-common,rainmaker-ws';else if (moduleName === 'rainmaker-ws') moduleNamecmn = 'rainmaker-common,rainmaker-pt';

              //const localeModule = (moduleName === 'rainmaker-common'||moduleName === null) ? 'rainmaker-common' : `rainmaker-common,${moduleName}`;
              localeModule = moduleName === 'rainmaker-common' || moduleName === null ? 'rainmaker-common' : moduleNamecmn + "," + moduleName;
              _context.prev = 4;
              _context.next = 7;
              return (0, _api.httpRequest)(_endPoints.LOCALATION.GET.URL, _endPoints.LOCALATION.GET.ACTION, [{ key: "module", value: localeModule }, { key: "locale", value: locale }, { key: "tenantId", value: _common2.default.tenantId }]);

            case 7:
              payload1 = _context.sent;

              // const payload2 = module
              //   ? await httpRequest(LOCALATION.GET.URL, LOCALATION.GET.ACTION, [
              //       { key: "module", value: `rainmaker-${module}` },
              //       { key: "locale", value: locale },
              //       { key: "tenantId", value: tenantId ? tenantId : commonConfig.tenantId },
              //     ])
              //   : [];
              //let resultArray = [...payload1.messages, ...payload2.messages];
              payload2 = [];
              resultArray = [].concat((0, _toConsumableArray3.default)(payload1.messages));

              if (payload2 && payload2.messages) {
                resultArray = [].concat((0, _toConsumableArray3.default)(resultArray), (0, _toConsumableArray3.default)(payload2.messages));
              }
              dispatch(setLocalizationLabels(locale, resultArray));
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              console.log(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[4, 14]]);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var setActionItems = function setActionItems(payload) {
  return {
    type: actionTypes.FETCH_ACTIONMENU,
    payload: payload
  };
};
//setdeviceinfo
var setdeviceinfo = function setdeviceinfo(payload) {
  return {
    type: actionTypes.FETCH_DEVICEINFO,
    payload: payload
  };
};
var setCurrentLocation = function setCurrentLocation(currentLocation) {
  return {
    type: actionTypes.SET_USER_CURRENT_LOCATION,
    currentLocation: currentLocation
  };
};

var addBreadCrumbs = exports.addBreadCrumbs = function addBreadCrumbs(url) {
  return { type: actionTypes.ADD_BREADCRUMB_ITEM, url: url };
};

var fetchCurrentLocation = exports.fetchCurrentLocation = function fetchCurrentLocation() {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var currAddress;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _commons.getCurrentAddress)();

            case 2:
              currAddress = _context2.sent;

              dispatch(setCurrentLocation(currAddress));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var searchActionItemError = exports.searchActionItemError = function searchActionItemError(error) {
  return { type: actionTypes.AUTHENTICATION_FAILED, error: error };
};
var fetchActionItems = exports.fetchActionItems = function fetchActionItems(role, ts) {
  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var payload;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, _api.httpRequest)(_endPoints.ACTIONMENU.GET.URL, _endPoints.ACTIONMENU.GET.ACTION, [], role, [], ts);

            case 3:
              payload = _context3.sent;


              dispatch(setActionItems(payload.actions));
              window.localStorage.setItem("ActionItems", true);
              //message for action data success
              // alert('pritam')
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              //dispatch(complaintFetchError(error.message));
              // dispatch(searchActionItemError(error.message));
              window.localStorage.setItem("ActionItems", false);
              // let redirectionRoute = "/user/login";
              //logout();
              // dispatch(setRoute(redirectionRoute));

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 8]]);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
//fetchdeviceinfo
var fetchdeviceinfo = exports.fetchdeviceinfo = function fetchdeviceinfo(role, ts) {
  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var payload;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, _api.httpRequest)(_endPoints.DEVICEINFO.GET.URL, _endPoints.DEVICEINFO.GET.ACTION, [], {}, [], {}, false, false);

            case 3:
              payload = _context4.sent;

              if (payload) {
                //dispatch(setdeviceinfo(payload));
                //localStorageSet("deviceinfo", payload);
                window.localStorage.setItem("deviceinfo", JSON.stringify(payload));
              }

              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              //dispatch(complaintFetchError(error.message));
              console.log(_context4.t0.message);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[0, 7]]);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var setUiCommonConfig = exports.setUiCommonConfig = function setUiCommonConfig(payload) {
  return {
    type: actionTypes.FETCH_UI_COMMON_CONFIG,
    payload: payload
  };
};

var setUiCommonConstants = exports.setUiCommonConstants = function setUiCommonConstants(payload) {
  return {
    type: actionTypes.FETCH_UI_COMMON_CONSTANTS,
    payload: payload
  };
};

var fetchUiCommonConfig = exports.fetchUiCommonConfig = function fetchUiCommonConfig() {
  _util.debug;
  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
      var requestBody, payload, MdmsRes, commonMasters, UiCommonConfig;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "uiCommonConfig"
                    }]
                  }]
                }
              };
              _context5.prev = 1;
              _context5.next = 4;
              return (0, _api.httpRequest)(_endPoints.MDMS.GET.URL, _endPoints.MDMS.GET.ACTION, [], requestBody);

            case 4:
              payload = _context5.sent;
              MdmsRes = payload.MdmsRes;
              commonMasters = MdmsRes["common-masters"];
              UiCommonConfig = commonMasters["uiCommonConfig"];

              dispatch(setUiCommonConfig(UiCommonConfig[0]));
              _context5.next = 14;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](1);

              console.log(_context5.t0);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, undefined, [[1, 11]]);
    }));

    return function (_x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var fetchUiCommonConstants = exports.fetchUiCommonConstants = function fetchUiCommonConstants() {
  _util.debug;
  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch) {
      var requestBody, payload, MdmsRes, commonMasters, UiCommonConstants;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "uiCommonConstants"
                    }]
                  }]
                }
              };
              _context6.prev = 1;
              _context6.next = 4;
              return (0, _api.httpRequest)(_endPoints.MDMS.GET.URL, _endPoints.MDMS.GET.ACTION, [], requestBody);

            case 4:
              payload = _context6.sent;
              MdmsRes = payload.MdmsRes;
              commonMasters = MdmsRes["common-masters"];
              UiCommonConstants = commonMasters["uiCommonConstants"];

              dispatch(setUiCommonConstants(UiCommonConstants[0]));
              _context6.next = 14;
              break;

            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](1);

              console.log(_context6.t0);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, undefined, [[1, 11]]);
    }));

    return function (_x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var fetchDeviceConstants = exports.fetchDeviceConstants = function fetchDeviceConstants() {
  _util.debug;
  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
      var requestBody, payload;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {}
              };
              _context7.prev = 1;
              _context7.next = 4;
              return (0, _api.httpRequest)(_endPoints.DEVICEINFO.GET.URL, _endPoints.DEVICEINFO.GET.ACTION, [], requestBody);

            case 4:
              payload = _context7.sent;

              // const { MdmsRes } = payload;
              // const commonMasters = MdmsRes["common-masters"];
              // const UiCommonConstants = commonMasters["uiCommonConstants"];
              // dispatch(setdeviceinfo(payload));
              window.localStorage.setItem("deviceinfo", JSON.stringify(payload));
              _context7.next = 11;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](1);

              console.log(_context7.t0);

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, undefined, [[1, 8]]);
    }));

    return function (_x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var setNotificationCount = exports.setNotificationCount = function setNotificationCount(count) {
  return {
    type: actionTypes.GET_NOTIFICATION_COUNT,
    count: count
  };
};

var getNotificationCount = exports.getNotificationCount = function getNotificationCount(queryObject, requestBody) {
  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
      var payload;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return (0, _api.httpRequest)(_endPoints.EVENTSCOUNT.GET.URL, _endPoints.EVENTSCOUNT.GET.ACTION, queryObject, requestBody);

            case 3:
              payload = _context8.sent;

              dispatch(setNotificationCount(payload.unreadCount));
              _context8.next = 10;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, undefined, [[0, 7]]);
    }));

    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var setNotificationsComplete = exports.setNotificationsComplete = function setNotificationsComplete(payload) {
  return {
    type: actionTypes.GET_NOTIFICATIONS_COMPLETE,
    payload: payload
  };
};

var setNotificationsPending = function setNotificationsPending() {
  return {
    type: actionTypes.GET_NOTIFICATIONS_PENDING
  };
};

var setNotificationsError = function setNotificationsError() {
  return {
    type: actionTypes.GET_NOTIFICATIONS_ERROR
  };
};

var getNotifications = exports.getNotifications = function getNotifications(queryObject, requestBody) {
  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
      var payload, transformedEvents;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch(setNotificationsPending());
              _context9.prev = 1;
              _context9.next = 4;
              return (0, _api.httpRequest)(_endPoints.NOTIFICATIONS.GET.URL, _endPoints.NOTIFICATIONS.GET.ACTION, queryObject, requestBody);

            case 4:
              payload = _context9.sent;
              _context9.next = 7;
              return (0, _commons.getTransformedNotifications)(payload.events);

            case 7:
              transformedEvents = _context9.sent;

              dispatch(setNotificationsComplete(transformedEvents));
              _context9.next = 14;
              break;

            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](1);

              dispatch(setNotificationsError(_context9.t0.message));

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, undefined, [[1, 11]]);
    }));

    return function (_x13, _x14) {
      return _ref9.apply(this, arguments);
    };
  }();
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/app/actions.js
// module id = 33
// module chunks = 895